var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReassign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C8 1.17157 8.67157 0.5 9.5 0.5H12.5C13.3284 0.5 14 1.17157 14 2V5C14 5.82843 13.3284 6.5 12.5 6.5H9.5C8.67157 6.5 8 5.82843 8 5V2ZM9.5 2H12.5V5H9.5V2Z",
    fill: "#173348"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 9.17157 0.671573 8.5 1.5 8.5H4.5C5.32843 8.5 6 9.17157 6 10V13C6 13.8284 5.32843 14.5 4.5 14.5H1.5C0.671573 14.5 0 13.8284 0 13V10ZM1.5 10H4.5V13H1.5V10Z",
    fill: "#173348"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 11.5C10.25 12.1904 9.69031 12.75 8.99996 12.75H7.99996C7.58574 12.75 7.24996 13.0858 7.24996 13.5C7.24996 13.9142 7.58574 14.25 7.99996 14.25H8.99996C10.5187 14.25 11.75 13.0188 11.75 11.5V10L12.55 10.6C12.8813 10.8485 13.3514 10.7814 13.6 10.45C13.8485 10.1186 13.7813 9.64853 13.45 9.4L11 7.5625L8.54996 9.4C8.21859 9.64853 8.15143 10.1186 8.39996 10.45C8.64848 10.7814 9.11859 10.8485 9.44996 10.6L10.25 10V11.5Z",
    fill: "#173348"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReassign);
export default __webpack_public_path__ + "static/media/reassign.000f9d11c84248267e32b3cc8ebcb555.svg";
export { ForwardRef as ReactComponent };